import { httpRequest } from "@services/http";
import { JourneyPath } from "@models/journeyPath.model";

export class CommandListJourneyPaths {
  async run(contractId: number, pricesheetId: number): Promise<JourneyPath[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/pricesheets/${pricesheetId}/journey-paths/`;
    const response = await httpRequest<any[]>(url, { method: "GET", cache: "no-store" });
    return response.map((row) => new JourneyPath(row));
  }
}
